<div fxLayout fxLayoutAlign="space-between" *transloco="let t">
  <p *ngIf="!data">
    {{ t.interceptors_login_snack_auth_required }}
  </p>
  <p *ngIf="data">{{ data }}</p>
  <button mat-button (click)="login()">{{ t.login }}</button>
  <button mat-button (click)="close()">{{ t.close }}</button>
</div>
